import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import SweetAlert from "sweetalert2";
import InputField from "./InputField";
import Card from "./Card";

const OtpSignup = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { phone } = location.state || {}; // Extract phone from location state

  const [otpInput, setOtpInput] = useState("");
  const [error, setError] = useState("");

  const handleOtpChange = (e) => {
    setOtpInput(e.target.value);
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Make API call to verify OTP and phone number
      const response = await axios.post("/member/validate_otp", {
        phone,
        otp: otpInput, // Pass the OTP and phone number to the backend
      });

      if (response.data.success) {
        const { zone_trainer_status } = response.data;

        if (zone_trainer_status === "unapproved") {
          SweetAlert.fire(
            "Success!",
            "Your registration has been done successfully... kindly await approval from the admin.",
            "success"
          ).then(() => navigate("/"));
        } else if (zone_trainer_status === "approved") {
          SweetAlert.fire(
            "Success!",
            "OTP verified! Redirecting to your dashboard...",
            "success"
          ).then(() => navigate("/dashboard"));
        }
      } else {
        // Handle invalid OTP
        SweetAlert.fire("Error!", "Invalid OTP. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      SweetAlert.fire(
        "Error!",
        "An error occurred while verifying the OTP. Please try again later.",
        "error"
      );
    }
  };

  return (
    <div className="relative min-h-screen">
      {/* Background Image */}
      <img
        src="/bg_image.jpg"
        alt="Background"
        className="absolute inset-0 object-cover w-full h-full z-0 filter grayscale hover:grayscale-0"
      />
      {/* Gray Overlay */}
      <div className="absolute inset-0 bg-gray-700 opacity-50 z-10" />
      {/* Content */}
      <div className="relative min-h-screen flex items-center justify-center z-20">
        <Card>
          <img src="/jci_logo.png" alt="Logo" className="w-24 mx-auto mb-6" />
          <h2 className="card-header">Verify OTP</h2>
          <p className="text-center text-gray-600 mb-6">
            Enter the OTP sent to {phone}
          </p>
          <form onSubmit={handleSubmit}>
            <InputField
              label="OTP"
              type="text"
              name="otp"
              value={otpInput}
              onChange={handleOtpChange}
              className="block w-full p-3 border rounded mb-4"
              placeholder="Enter OTP"
              required
            />
            {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
            <button
              type="submit"
              className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
            >
              Verify and Create Account
            </button>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default OtpSignup;
